import {
  AnalyticsClient,
  AnalyticsAdapter,
} from '../../../utils/analytics/analyticsAdapter'
import { AnalyticsContext } from './AnalyticsContext'

type AnalyticsProviderProps = {
  client: AnalyticsClient
  children: JSX.Element
}

export const AnalyticsProvider = ({
  client,
  children,
}: AnalyticsProviderProps) => {
  const analyticsAdapter: AnalyticsAdapter = new AnalyticsAdapter(client)

  return (
    <AnalyticsContext.Provider value={{ analytics: analyticsAdapter }}>
      {children}
    </AnalyticsContext.Provider>
  )
}
